module.exports = __webpack_public_path__ + "media/images/lb/089-8d11118825796ee9b65ad78c68ad6c48.svg";